export const defaultFields = [
    'ФИО',
    'Дата рождения',
    'Период действия',
    'Статус',
    'Номер полиса',
    'Вариант',
    'Табельный номер'
];
export const allFields = [
    'ФИО',
    'Дата рождения',
    'Период действия',
    'Статус',
    'Номер заявки',
    'Номер полиса',
    'Вариант',
    'Адрес',
    'Почта',
    'Телефон',
    'Должность',
    'Пол',
    'Индивидуальный лимит',
    'Остаток по индивидуальному лимиту',
    'Табельный номер'
];
export const fieldMappings: Record<string, string> = {
    'ФИО': 'FullName',
    'Дата рождения': 'BirthDate',
    'Период действия': 'StartDateEndDate',
    'Статус': 'Active',
    'Номер заявки': 'TaskNumber',
    'Номер полиса': 'PolicyNumber',
    'Вариант': 'InsuranceProgramPrintName',
    'Адрес': 'Address',
    'Почта': 'Email',
    'Телефон': 'Phone',
    'Должность': 'Job',
    'Пол': 'Gender',
    'Индивидуальный лимит': 'IndividualLimit',
    'Остаток по индивидуальному лимиту': 'ResidualPremiumBySpecialProgram',
    'Табельный номер': 'PersonnelNumber',
};